import { useCallback } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { DateVariant, dateToPrint } from '@/modules/common/utils/date-format.ts';
import { issuerDashboardPaths } from '@/modules/issuer-dashboard/routes.tsx';
import { DisclosureListItem } from 'ui';
import { fixNameEnum } from 'ui/utils';
import { ShareholderExtendResponse } from 'api';

interface BankInfoVerificationRequestItemProps {
  shareholder: ShareholderExtendResponse;
}

export const BankInfoVerificationRequestItem = ({
  shareholder,
}: BankInfoVerificationRequestItemProps) => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { pathname } = useLocation();

  const openHolder = useCallback(() => {
    navigate(
      {
        pathname: issuerDashboardPaths.dynamic.holder(String(shareholder.entity_id)),
        search: params.toString(),
      },
      {
        state: { from: pathname + '?' + params.toString() },
      },
    );
  }, [navigate, params, pathname, shareholder.entity_id]);

  return (
    <DisclosureListItem
      onClick={openHolder}
      leftMainString={
        <>
          {shareholder.entity?.entity_name || 'Entity name is unset'}
          {!!shareholder.entity?.type && ` (${fixNameEnum(shareholder.entity.type)})`}
        </>
      }
      leftSubduedContentSet={[
        dateToPrint(shareholder.entity?.payment_info_requested_at, DateVariant.Dashboard, true),
      ]}
      classes={{ leftContent: 'w-[200px]' }}
    />
  );
};
